import { render } from "./Carousel-large.vue?vue&type=template&id=72457dce&scoped=true"
import script from "./Carousel-large.vue?vue&type=script&lang=js"
export * from "./Carousel-large.vue?vue&type=script&lang=js"

import "./Carousel-large.vue?vue&type=style&index=0&id=72457dce&scoped=true&lang=css"

import exportComponent from "/Users/agroinnovatech/Development/Agro-Innova/AgroInnovaWebsite/AgroInnovaWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72457dce"]])

export default __exports__